import React from "react";
import { createPortal } from "react-dom";
import "./styles.css";

// Базовая модалка: оверлей + окно; клик по оверлею или крестику — closeModal.
// Рисуется порталом в document.body: модалки открывают и из ячеек таблиц, а там свои стили (в плотной
// таблице — white-space: nowrap), которые иначе унаследовало бы окно: текст не переносился и уходил
// за край. React-события через портал всплывают по дереву компонентов, как и раньше.
export default function Modal({ isOpenModal, closeModal, title, className = '', children }) {
    if (!isOpenModal) return null;
    return createPortal(<div className="modal" onMouseDown={closeModal}>
        <div
            className={`modal__window ${className}`}
            onMouseDown={(event) => event.stopPropagation()}
        >
            <div className="modal__header">
                <div className="modal__title">{title}</div>
                <button className="modal__close" title="Закрыть" onClick={closeModal}>×</button>
            </div>
            <div className="modal__body">{children}</div>
        </div>
    </div>, document.body);
}
